<script>
  import { Question } from "../../models/Question.js";
  import { txt } from "../../i18n/i18n";

  /** @type {Question} */
  export let question;

  function getGradientClass(num, total) {
    const percent = Math.round((num * 100) / total);

    if (!percent || percent < 20) {
      return null;
    }
    if (percent < 40) {
      return "gradient1";
    }
    if (percent < 60) {
      return "gradient2";
    }
    if (percent < 80) {
      return "gradient3";
    }
    return "gradient4";
  }
</script>

<div class="scrollable">
    <table class="matrix-sum">
        <thead>
            <tr>
                <th>&nbsp;</th>
                <th scope="col">{txt('Responses')}</th>
                {#each question.alternatives as alt}
                    <th scope="col">{alt.text}</th>
                {/each}
            </tr>
        </thead>
        <tbody>
            {#each question.matrixRows as row}
                <tr>
                    <th scope="row">{row.text}</th>
                    <td class="num-ans">{row.numberOfAnswers}</td>
                    {#each row.alternatives as alt}
                        <td class="{getGradientClass(alt.numberOfAnswers, row.numberOfAnswers)}">{alt.numberOfAnswers}</td>
                    {/each}
                </tr>
            {/each}
        </tbody>
    </table>
</div>
